export const breadcrumbInformeDicom = [
    { label: 'Inicio', url: '/' },
    { label: 'Cobranzas', url: `/cobranzas` },
    { label: 'Informe DICOM', active: true },
]